(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-loox"] && !Shopify.designMode) return;
  try {
    
(function () {
  function buildSection(section) {
    if (section.dataset.looxInit === '1') return;
    section.dataset.looxInit = '1';

    var track = section.querySelector('.loox-reviews__track');
    if (!track) return;
    var isGrid = section.classList.contains('loox-reviews--grid');

    var rafId = null;
    function layout() {
      if (!isGrid) return;
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        track.classList.add('is-masonry');
        var cards = Array.prototype.filter.call(track.querySelectorAll('.loox-card'), function (c) {
          return c.style.display !== 'none';
        });
        cards.forEach(function (c) { c.style.gridRowEnd = ''; });
        var heights = cards.map(function (c) { return c.getBoundingClientRect().height; });
        cards.forEach(function (c, i) { c.style.gridRowEnd = 'span ' + Math.ceil((heights[i] + 20) / 8); });
      });
    }

    function checkClamp() {
      section.querySelectorAll('.loox-card').forEach(function (card) {
        var text = card.querySelector('[data-loox-text]');
        var more = card.querySelector('[data-loox-more]');
        if (!text || !more || text.classList.contains('is-expanded')) return;
        more.hidden = !(text.scrollHeight - text.clientHeight > 4);
      });
    }

    section.querySelectorAll('[data-loox-more]').forEach(function (more) {
      more.addEventListener('click', function () {
        var card = more.closest('.loox-card');
        var text = card.querySelector('[data-loox-text]');
        var expanded = text.classList.toggle('is-expanded');
        more.textContent = expanded ? (more.getAttribute('data-less') || 'Show less') : (more.getAttribute('data-more') || 'Read more');
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        layout();
      });
    });

    var prev = section.querySelector('[data-loox-prev]');
    var next = section.querySelector('[data-loox-next]');
    function step() {
      var card = track.querySelector('.loox-card');
      return card ? card.offsetWidth + 20 : track.clientWidth * 0.8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var dialog = section.querySelector('[data-loox-dialog]');
    if (dialog && typeof dialog.showModal === 'function') {
      var triggers = Array.prototype.slice.call(section.querySelectorAll('[data-loox-open]'));
      var lbImg = dialog.querySelector('[data-loox-lb-img]');
      var lbStars = dialog.querySelector('[data-loox-lb-stars]');
      var lbText = dialog.querySelector('[data-loox-lb-text]');
      var lbAuthor = dialog.querySelector('[data-loox-lb-author]');
      var lbMeta = dialog.querySelector('[data-loox-lb-meta]');
      var prevB = dialog.querySelector('[data-loox-lb-prev]');
      var nextB = dialog.querySelector('[data-loox-lb-next]');
      var current = 0;

      function populate(i) {
        if (!triggers.length) return;
        if (i < 0) i = triggers.length - 1;
        if (i >= triggers.length) i = 0;
        current = i;
        var card = triggers[i].closest('.loox-card');
        if (lbImg) { lbImg.src = triggers[i].getAttribute('data-img') || ''; lbImg.alt = triggers[i].getAttribute('data-alt') || ''; }
        var s = card.querySelector('.loox-stars');
        if (lbStars) lbStars.innerHTML = s ? s.innerHTML : '';
        var t = card.querySelector('[data-loox-text]');
        if (lbText) lbText.innerHTML = t ? t.innerHTML : '';
        var a = card.querySelector('.loox-card__name');
        if (lbAuthor) lbAuthor.textContent = a ? a.textContent : '';
        var m = card.querySelector('.loox-card__meta');
        if (lbMeta) lbMeta.textContent = m ? m.textContent : '';
      }

      triggers.forEach(function (btn, i) {
        btn.addEventListener('click', function () { populate(i); dialog.showModal(); });
      });
      if (prevB) prevB.addEventListener('click', function () { populate(current - 1); });
      if (nextB) nextB.addEventListener('click', function () { populate(current + 1); });
      if (triggers.length <= 1) { if (prevB) prevB.hidden = true; if (nextB) nextB.hidden = true; }
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); populate(current - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); populate(current + 1); }
      });
      var closeBtn = dialog.querySelector('[data-loox-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }

    var filters = section.querySelector('.loox-filters');
    if (filters) {
      filters.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-loox-filter]');
        if (!btn) return;
        var f = btn.getAttribute('data-loox-filter');
        filters.querySelectorAll('[data-loox-filter]').forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        var anyVisible = false;
        track.querySelectorAll('.loox-card').forEach(function (card) {
          var show = true;
          if (f === 'photo') show = card.getAttribute('data-photo') === '1';
          else if (f !== 'all') show = card.getAttribute('data-rating') === f;
          card.style.display = show ? '' : 'none';
          if (show) anyVisible = true;
        });
        var empty = section.querySelector('[data-loox-empty]');
        if (empty) empty.hidden = anyVisible;
        layout();
      });
    }

    checkClamp();
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { checkClamp(); layout(); }, { once: true });
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { checkClamp(); layout(); });
    }

    if (isGrid) {
      layout();
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function () { layout(); });
        ro.observe(track);
      }
      if ('IntersectionObserver' in window && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        var cards = track.querySelectorAll('.loox-card');
        track.classList.add('loox-reveal-init');
        cards.forEach(function (card, i) { card.style.setProperty('--loox-delay', (i % 10) * 40 + 'ms'); });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
          });
        }, { threshold: 0.1 });
        cards.forEach(function (card) { io.observe(card); });
      }
    }
  }

  function initAll() { document.querySelectorAll('.loox-reviews').forEach(buildSection); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.loox-reviews');
    if (section) { section.dataset.looxInit = ''; buildSection(section); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
